import * as React from 'react';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Box,
} from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link as RouterLink } from 'react-router-dom';

import { VerticalNavProps, verticalNavStyles } from './helpLinks-helpers';

export const HelpLinks = ({
    links = [],
    onClose,
}: VerticalNavProps): JSX.Element | null => {
    return (
        <List sx={verticalNavStyles.list}>
            {links.map((link): JSX.Element => {
                const isExternal = link.external === true;
                const isInternal = link.external !== true;

                return (
                    <ListItem disablePadding key={link.label}>
                        <ListItemButton
                            component={isExternal ? 'a' : RouterLink}
                            href={isExternal ? link.href : undefined}
                            to={isInternal ? link.href : undefined}
                            target={isExternal ? '_blank' : undefined}
                            rel={isExternal ? 'noopener noreferrer' : undefined}
                            disabled={link.disabled}
                            onClick={(): void => {
                                if (isInternal) {
                                    onClose?.();
                                }
                            }}
                            sx={verticalNavStyles.listItemButton}
                        >
                            <ListItemText
                                primary={link.label}
                                primaryTypographyProps={
                                    verticalNavStyles.listItemText
                                }
                            />

                            {isExternal && (
                                <Box sx={verticalNavStyles.iconBox}>
                                    <LaunchIcon
                                        fontSize='small'
                                        sx={verticalNavStyles.icon}
                                    />
                                </Box>
                            )}
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>
    );
};
